import { a, f } from "./feature-toggles.js";
import { g } from "./google-tag-manager.js";
export {
  a as apiConfig,
  f as featureToggles,
  g as gtmConfig
};
//# sourceMappingURL=configuration.js.map
